import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock } from 'lucide-react';
export function SolutionSection() {
  const outcomes = ['Cada foto, mensaje y decisión queda respaldada — aunque borren el grupo', 'Busca por fecha, persona, sector o palabra clave en segundos', 'Resumen automático de cada semana: avances, problemas, decisiones', 'Genera reportes PDF cuando los necesites — para cobrar, para el mandante, para lo que sea'];
  return <section id="solucion" className="py-10 sm:py-12 bg-gray-50" data-id="element-282">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-283">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-284">
          {/* Left column - Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-285">
            <div className="inline-block px-4 py-1.5 bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-wider rounded-full mb-4" data-id="element-286">
              La solución
            </div>

            <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-287">
              De tu WhatsApp a un registro ordenado. Automático.
            </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-288">
              Tu equipo sigue mandando fotos y mensajes como siempre. Obra
              Digital los captura, ordena y respalda. Tú decides qué hacer con
              esa info.
            </p>

            <div className="space-y-3 mb-8" data-id="element-289">
              {outcomes.map((outcome, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-290">
                  <CheckCircle2 className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-291" />
                  <p className="text-gray-700 font-medium" data-id="element-292">{outcome}</p>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="flex items-start gap-3 p-4 bg-blue-50 rounded-xl border border-blue-100" data-id="element-293">
              <Lock className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-294" />
              <p className="text-sm font-medium text-blue-900" data-id="element-295">
                Cuando alguien borre la foto del WhatsApp, tu respaldo seguirá
                ahí.
              </p>
            </motion.div>
          </motion.div>

          {/* Right column - Before/After */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-6" data-id="element-296">
            {/* Before */}
            <div className="relative bg-white rounded-2xl p-6 border border-gray-200 shadow-lg" data-id="element-297">
              <div className="absolute -top-3 left-6 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-298">
                Antes
              </div>

              <div className="relative h-[240px] bg-gradient-to-br from-gray-100 to-gray-50 rounded-xl overflow-hidden" data-id="element-299">
                {/* Chaotic photos */}
                <div className="absolute top-4 left-4 w-20 h-20 bg-gray-300 rounded-lg shadow-md transform -rotate-12" data-id="element-300" />
                <div className="absolute top-8 right-6 w-16 h-16 bg-gray-300 rounded-lg shadow-md transform rotate-6" data-id="element-301" />
                <div className="absolute bottom-12 left-8 w-24 h-24 bg-gray-300 rounded-lg shadow-md transform rotate-12" data-id="element-302" />
                <div className="absolute bottom-6 right-4 w-20 h-20 bg-gray-300 rounded-lg shadow-md transform -rotate-6" data-id="element-303" />

                {/* Chat bubble */}
                <div className="absolute bottom-4 left-4 bg-white rounded-xl rounded-bl-none px-3 py-2 shadow-lg max-w-[200px]" data-id="element-304">
                  <p className="text-xs text-gray-600" data-id="element-305">
                    "¿Dónde está la foto de la losa del martes?"
                  </p>
                </div>
              </div>
            </div>

            {/* After */}
            <div className="relative bg-white rounded-2xl p-6 border border-blue-200 shadow-lg" data-id="element-306">
              <div className="absolute -top-3 left-6 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-307">
                Después
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-white rounded-xl p-5 border border-blue-100" data-id="element-308">
                {/* Header */}
                <div className="mb-4 pb-3 border-b border-gray-200" data-id="element-309">
                  <h4 className="text-sm font-bold text-gray-900" data-id="element-310">
                    Resumen semanal · Proyecto Centro
                  </h4>
                </div>

                {/* Mini KPI cards */}
                <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-311">
                  <div className="bg-white rounded-lg p-2 border border-gray-200 text-center" data-id="element-312">
                    <div className="text-lg font-bold text-blue-600" data-id="element-313">12</div>
                    <div className="text-[10px] text-gray-600" data-id="element-314">Avances</div>
                  </div>
                  <div className="bg-white rounded-lg p-2 border border-gray-200 text-center" data-id="element-315">
                    <div className="text-lg font-bold text-green-600" data-id="element-316">3</div>
                    <div className="text-[10px] text-gray-600" data-id="element-317">Decisiones</div>
                  </div>
                  <div className="bg-white rounded-lg p-2 border border-gray-200 text-center" data-id="element-318">
                    <div className="text-lg font-bold text-amber-600" data-id="element-319">2</div>
                    <div className="text-[10px] text-gray-600" data-id="element-320">Problemas</div>
                  </div>
                </div>

                {/* Summary items */}
                <div className="space-y-2" data-id="element-321">
                  <div className="flex items-start gap-2" data-id="element-322">
                    <div className="w-2 h-2 rounded-full bg-green-500 mt-1.5 flex-shrink-0" data-id="element-323" />
                    <p className="text-xs text-gray-700" data-id="element-324">
                      Avance del 18% en losa piso 3
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-325">
                    <div className="w-2 h-2 rounded-full bg-blue-500 mt-1.5 flex-shrink-0" data-id="element-326" />
                    <p className="text-xs text-gray-700" data-id="element-327">
                      Cambio de proveedor aprobado
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-328">
                    <div className="w-2 h-2 rounded-full bg-amber-500 mt-1.5 flex-shrink-0" data-id="element-329" />
                    <p className="text-xs text-gray-700" data-id="element-330">
                      Retraso de 2 días por lluvia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}